import React, { useEffect } from "react"
import { GridSortItem } from "@mui/x-data-grid-pro"
import { ITableColumn } from "../../components/TableColumns"
import { useTableContext } from "../../provider"
import { getLocalStorageValues, setLocalStorageValues, TableLocalStorageKey } from "../../helpers"

export const InitializerSorting = () => {

  const ctx = useTableContext()
  const { tableId } = ctx.props

  useEffect(() => {
    const getSortModelFromColumns = (tableId: string, columns: ITableColumn[]) => {
      const defaultSortColumn = columns
        .find((item: ITableColumn) =>
          item.defaultSort && item.field
        )

      if (!defaultSortColumn) {
        return []
      }

      const sortModel: GridSortItem[] = [{
        field: defaultSortColumn.field,
        sort: defaultSortColumn.defaultSort
      }]

      setLocalStorageValues(tableId, TableLocalStorageKey.sortModel, sortModel)
      return sortModel
    }

    const sortModel = getLocalStorageValues(tableId, TableLocalStorageKey.sortModel)
      || getSortModelFromColumns(tableId, ctx.props.columns)

    ctx.data.api.setSort(sortModel)
    ctx.lifecycle.increment()
  }, [])

  return (<></>)
}
